import { useEffect, useRef } from "react";

// Phase 28 — F12 light: browser beforeunload + react navigation block when dirty.
// Usage:
//   useUnsavedChanges(isDirty, "You have unsaved changes...");
//
// `isDirty` should be a boolean ref or value indicating dirty state.
export function useUnsavedChanges(isDirty, message = "Ungespeicherte Änderungen — Möchten Sie speichern oder verwerfen?") {
  const isDirtyRef = useRef(isDirty);
  isDirtyRef.current = isDirty;

  useEffect(() => {
    const handler = (e) => {
      if (!isDirtyRef.current) return;
      e.preventDefault();
      e.returnValue = message; // Chrome requires returnValue set
      return message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [message]);
}

export default useUnsavedChanges;
